import { apiCallWrapper, EntitiesPaginatedModel, SelectOptionModel } from 'traveldesk-ui'
import { TourManageTableModel, TourManageModel } from '../models/TourManageModel'
import { TourImportModel } from '../pages/TourImport/TourImportModel'

export default class ToursApiService {
    static publish = async (dispatch: any, tourId: number) => {
        return await apiCallWrapper<number>(`/api/tours/publish`, 'POST', dispatch, {tourId: tourId} )
    }
    static save = async (dispatch: any, model: TourManageModel) => {
        return await apiCallWrapper<TourManageModel>('/api/tours', model.id == 0 ? 'POST' : 'PUT', dispatch, model)
    }
    static import = async (dispatch: any, apiProviderId: number, importModel: TourImportModel) => {
        return await apiCallWrapper<number>(`/api/tours/import/${apiProviderId}`, 'POST', dispatch, importModel )
    }
    static getToursManageTable = async (dispatch: any) => {
        return await apiCallWrapper<TourManageTableModel[]>('/api/tours/manageList', 'GET', dispatch)
    }
    static getToursManageTableExternal = async (dispatch: any) => {
        return await apiCallWrapper<EntitiesPaginatedModel<TourManageTableModel>>('/api/tours/manageListExternal', 'GET', dispatch)
    }
    static getTourTranslation = async (dispatch: any, id: number, languageId: number) => {
        return await apiCallWrapper<TourManageModel>(`/api/tours/translation/${id}?languageId=${languageId}`, 'GET', dispatch)
    }
    static getTourTranslatedTo = async (dispatch: any, id: number) => {
        return await apiCallWrapper<SelectOptionModel[]>(`/api/tours/translatedto/${id}`, 'GET', dispatch)
    }
    static getTourForEdit = async (dispatch: any, id: number) => {
        return await apiCallWrapper<TourManageModel>(`/api/tours/manage/${id}`, 'GET', dispatch)
    }
    static getCategoriesOptions = async (dispatch: any) => {
        return await apiCallWrapper<SelectOptionModel[]>('/api/toursCategories/options', 'GET', dispatch)
    }
    static getRecommendedForOptions = async (dispatch: any) => {
        return {
            IsOk: true,
            Code: 200,
            Content: [
                { value: 0, label: 'Everybody' },
                { value: 1, label: 'Families With Children' },
                { value: 2, label: 'Families With Infants' },
                { value: 3, label: 'Young Adults' },
                { value: 4, label: 'Elderly' },
            ],
        }
    }
}
